(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_faq-item"] && !Shopify.designMode) return;
  try {
    class FaqItem extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.faq-item__question');
      this.answer = this.querySelector('.faq-item__answer');
      this.toggle = this.querySelector('.faq-item__toggle');
      this.init();
    }

    init() {
      if (this.button) {
        this.button.addEventListener('click', () => this.toggleAnswer());
      }
    }

    toggleAnswer() {
      const isOpen = this.answer.classList.contains('faq-item__answer--open');

      // Close other items in the same category
      const category = this.closest('.faq-category');
      if (category) {
        category.querySelectorAll('faq-item').forEach(item => {
          if (item !== this) {
            const otherAnswer = item.querySelector('.faq-item__answer');
            const otherToggle = item.querySelector('.faq-item__toggle');
            const otherButton = item.querySelector('.faq-item__question');
            if (otherAnswer && otherAnswer.classList.contains('faq-item__answer--open')) {
              otherAnswer.classList.remove('faq-item__answer--open');
              if (otherToggle) otherToggle.classList.remove('faq-item__toggle--open');
              if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
            }
          }
        });
      }

      // Toggle current item
      if (isOpen) {
        this.answer.classList.remove('faq-item__answer--open');
        this.toggle.classList.remove('faq-item__toggle--open');
        this.button.setAttribute('aria-expanded', 'false');
      } else {
        this.answer.classList.add('faq-item__answer--open');
        this.toggle.classList.add('faq-item__toggle--open');
        this.button.setAttribute('aria-expanded', 'true');
      }
    }
  }

  if (!customElements.get('faq-item')) {
    customElements.define('faq-item', FaqItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq"] && !Shopify.designMode) return;
  try {
    class FaqBlock extends HTMLElement {
    constructor() {
      super();
      this.tabsContainer = this.querySelector('.faq-block__tabs');
      this.categories = this.querySelectorAll('.faq-category');
      this.modal = this.querySelector('.faq-video-modal');
      this.modalVideo = this.modal ? this.modal.querySelector('.faq-video-modal__video') : null;
      this.init();
      this.initVideoModal();
    }

    initVideoModal() {
      if (!this.modal || !this.modalVideo) return;

      this.addEventListener('click', (event) => {
        const link = event.target.closest('.faq-item__answer a[href$=".mp4"]');
        if (!link) return;
        event.preventDefault();
        this.openVideo(link.getAttribute('href'));
      });

      this.modal.querySelectorAll('[data-video-close]').forEach((el) => {
        el.addEventListener('click', () => this.closeVideo());
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.modal.hasAttribute('hidden')) {
          this.closeVideo();
        }
      });
    }

    openVideo(src) {
      this.modalVideo.src = src;
      this.modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      const playPromise = this.modalVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    }

    closeVideo() {
      this.modalVideo.pause();
      this.modalVideo.removeAttribute('src');
      this.modalVideo.load();
      this.modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    init() {
      // Generate tabs from category data attributes
      this.categories.forEach((category, index) => {
        const title = category.dataset.categoryTitle;
        const categoryId = category.dataset.categoryId;

        const tab = document.createElement('button');
        tab.className = 'faq-block__tab' + (index === 0 ? ' faq-block__tab--active' : '');
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        tab.setAttribute('aria-controls', 'faq-category-' + categoryId);
        tab.setAttribute('data-tab-target', categoryId);
        tab.setAttribute('data-testid', 'faq-tab');
        tab.textContent = title;

        tab.addEventListener('click', () => this.switchTab(tab));
        this.tabsContainer.appendChild(tab);
      });

      this.tabs = this.querySelectorAll('.faq-block__tab');

      // Ensure first category is visible on init
      if (this.categories.length > 0) {
        this.categories.forEach((category, index) => {
          if (index === 0) {
            category.classList.add('faq-category--active');
            category.removeAttribute('hidden');
          } else {
            category.classList.remove('faq-category--active');
            category.setAttribute('hidden', '');
          }
        });
      }
    }

    switchTab(clickedTab) {
      const targetId = clickedTab.dataset.tabTarget;

      // Update tabs
      this.tabs.forEach(tab => {
        tab.classList.remove('faq-block__tab--active');
        tab.setAttribute('aria-selected', 'false');
      });
      clickedTab.classList.add('faq-block__tab--active');
      clickedTab.setAttribute('aria-selected', 'true');

      // Update category panels
      this.categories.forEach(category => {
        if (category.dataset.categoryId === targetId) {
          category.classList.add('faq-category--active');
          category.removeAttribute('hidden');
        } else {
          category.classList.remove('faq-category--active');
          category.setAttribute('hidden', '');
        }
      });
    }
  }

  if (!customElements.get('faq-block')) {
    customElements.define('faq-block', FaqBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["payjustnow"] && !Shopify.designMode) return;
  try {
    class PayJustNowMessage extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.shopify-section, dialog');
      this.scope?.addEventListener('variant:update', this.onVariantUpdate);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.scope?.removeEventListener('variant:update', this.onVariantUpdate);
    }

    get modal() {
      return this.querySelector('dialog.pjn-modal');
    }

    onClick = (event) => {
      const modal = this.modal;
      if (!modal) return;

      if (event.target.closest('[data-pjn-open]')) {
        event.preventDefault();
        if (typeof modal.showModal === 'function') {
          modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }
        return;
      }

      if (event.target.closest('[data-pjn-close]') || event.target === modal) {
        event.preventDefault();
        modal.close();
      }
    };

    onVariantUpdate = (event) => {
      const detail = event.detail;
      const data = detail?.data;
      if (!data?.html) return;

      if (data.newProduct) {
        this.dataset.productId = data.newProduct.id;
      } else if (
        event.target instanceof HTMLElement &&
        event.target.dataset.productId &&
        event.target.dataset.productId !== this.dataset.productId
      ) {
        return;
      }

      const next =
        data.html.querySelector(`payjustnow-message[data-block-id="${this.dataset.blockId}"]`) ||
        data.html.querySelector('payjustnow-message');
      if (!next) return;

      for (const ref of ['pjnContent', 'pjnBreakdown']) {
        const current = this.querySelector(`[ref="${ref}"]`);
        const replacement = next.querySelector(`[ref="${ref}"]`);
        if (current && replacement && current.innerHTML !== replacement.innerHTML) {
          current.innerHTML = replacement.innerHTML;
        }
      }

      this.toggleAttribute('data-hidden', next.hasAttribute('data-hidden'));
    };
  }

  if (!customElements.get('payjustnow-message')) {
    customElements.define('payjustnow-message', PayJustNowMessage);
  }
  } catch(e) { console.error(e); }
})();

})();
